(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-hubspot-blogs-three"] && !Shopify.designMode) return;
  try {
    
    // Fecthing blogs from Hubspot

    fetch("https://blog.agriculture.redmond.com/rss.xml")
      .then((response) => response.text())
      .then((xmlString) => {
        // console.log(xmlString);
        // Parse the XML string into an XML Document object
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlString, "text/xml");

        // Access elements in the XML tree
        const root = xmlDoc.documentElement;
        const children = root.children;
        var blog_data = [];
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          // console.log(child.tagName, child.getAttribute('id'));
          const subChildren = child.children;
          for (let j = 0; j < subChildren.length; j++) {
            const subChild = subChildren[j];
            // console.log('subChild:' , subChild);
            if (subChild.nodeName === "item") {
              // console.log(subChild)
              let title = subChild.querySelector("title").textContent;
              let link = subChild.querySelector("link").textContent;

              let description = subChild.querySelector("description");

              let descriptionTextOuter = description.textContent;
              let tempElement = document.createElement('div');
              tempElement.innerHTML = descriptionTextOuter;


              // let descriptionTextInner = tempElement.querySelector("p").textContent;
              let paragraphs = tempElement.querySelectorAll("p");
  let lastParagraph = paragraphs[paragraphs.length - 1];
  let descriptionTextInner = lastParagraph.textContent;

              let img = description.textContent.match('srcs*=s*"(.+?)"')[1];
              blog_data.push({
                title,
                link,
                img,
                descriptionTextInner
              });
            }
          }
        }
        // console.log("Blogs datas:",blog_data)

        const blogsContainer = document.querySelector(
          ".featured-blogs--inner.container .content-wrapper"
        );

        blog_data.slice(0, 3).forEach((blog) => {
          let div = document.createElement("div");
          let img = document.createElement("img");
          let h4 = document.createElement("h4");
          let p = document.createElement("p");
          let a = document.createElement("a");

          img.src = blog.img;
          img.alt = blog.title;
          h4.textContent = blog.title;
          p.textContent = blog.descriptionTextInner;
          a.classList.add("blog-cta-action");
          a.href = blog.link;
          a.textContent = "Read More"

          div.appendChild(img);
          div.appendChild(h4);
          div.appendChild(p);
          div.appendChild(a);

          blogsContainer.appendChild(div);
        });
      })
      .catch((err) => {
        console.log("err: ", err);
      });

    // end of fecthing blogs from Hubspot

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-content-module"] && !Shopify.designMode) return;
  try {
    
  let acc = document.querySelectorAll(".homepage-accordian");
  let i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      let panel = this.previousElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  };

  } catch(e) { console.error(e); }
})();
})();
